import React from "react";
import styled from "styled-components";

const Wrapper = styled.svg`
  width: auto;
  height: 2.625rem;
  margin-top: 0.125rem;
`;
export default function Bois() {
  return (
    <Wrapper
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M458 261C469.047 261 478 252.047 478 241V107.222C478.269 106.4 478.484 105.547 478.65 104.675L509.722 45.2688C511.219 42.4094 512 39.2313 512 36V20C512 8.95313 503.047 0 492 0H20C8.95313 0 0 8.95313 0 20V35C0 38.1063 0.721875 41.1688 2.10938 43.9438L33 105.722V392H20C8.95313 392 0 400.953 0 412V492C0 503.047 8.95313 512 20 512H492C503.047 512 512 503.047 512 492V412C512 400.953 503.047 392 492 392H478V341C478 329.953 469.047 321 458 321C446.953 321 438 329.953 438 341V392H399V242.069C399 220.469 387.288 200.438 368.441 189.788C345.194 176.656 306.644 161 255 161C203.5 161 166.063 176.591 143.722 189.669C125.391 200.403 114 220.25 114 241.472V392H73V121H438V241C438 252.047 446.953 261 458 261ZM472 472H40V432H472V472ZM229 331C229 321.444 237.513 307.713 248.719 294.903C255.181 303.75 263.391 309.619 269.894 314.266C280.684 321.975 283 324.266 283 331C283 345.888 270.888 358 256 358C241.113 358 229 345.888 229 331ZM154 241.472C154 234.4 157.806 227.775 163.934 224.188C182 213.609 212.466 201 255 201C297.953 201 329.7 213.844 348.766 224.613C355.078 228.181 359 234.872 359 242.069V392H283.659C306.838 381.45 323 358.088 323 331C323 303.05 305.034 290.216 293.153 281.722C281.894 273.681 278 270.369 278 260C278 248.953 269.047 240 258 240H256C251.356 240 246.859 241.619 243.275 244.569C239.597 247.6 226.644 258.663 214.313 273.688C197.516 294.153 189 313.438 189 331C189 358.088 205.163 381.45 228.341 392H154V241.472ZM467.338 40L445.891 81H65.3594L44.8594 40H467.338Z"
        className="fill"
      />
    </Wrapper>
  );
}
